export const CURRENCY_DEFAULT = 'USD';
